import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ShimmerImage } from 'Elements';
import { VoucherUsageInfo } from 'Types';
import { formatLocaleDateTime } from 'Utils';
import styles from 'partials/card/voucher-card.module.scss';

interface Props {
	businessPartners: VoucherUsageInfo[] | null;
}

export const VoucherCompanies: FC<Props> = ({ businessPartners }) => {
	const defaultImage = '/assets/img/business-partner-default.png';
	const { t } = useTranslation();

	return (
		<div className="h-100 d-flex flex-column">
			<h5 className="text-gray-3 mb-3 fs-5 fw-400">
				{t('title.companies-list')}
			</h5>
			<div className="flex-grow-1">
				{businessPartners?.map((businessPartner) => (
					<div
						key={businessPartner.businessPartnerId}
						className={styles.businessPartner}>
						<div className={styles.businessPartnerLogoWrapper}>
							<ShimmerImage
								src={
									businessPartner.businessPartnerLogo
										.thumbnail
								}
								alt={businessPartner.businessPartnerName}
								defaultImage={defaultImage}
								width={50}
								height={50}
								className={styles.businessPartnerLogo}
							/>
						</div>
						<div className="d-flex flex-column flex-grow-1">
							<h6 className="fw-500 lh-base mb-1">
								{businessPartner.businessPartnerName ?? '---'}
							</h6>
							<time
								className="text-gray-3"
								title={formatLocaleDateTime(
									businessPartner.usageDateTime,
									false
								)}
								dateTime={formatLocaleDateTime(
									businessPartner.usageDateTime,
									false
								)}>
								{`${t(
									'label.usage-date'
								)}: ${formatLocaleDateTime(
									businessPartner.usageDateTime,
									false
								)}`}
							</time>
						</div>
					</div>
				))}
				{businessPartners?.length === 0 && (
					<div className="d-flex align-items-center justify-content-center text-gray-3 text-center">
						{t('title.no-companies-use-voucher')}
					</div>
				)}
			</div>
		</div>
	);
};
